import { useState, useEffect } from 'react';
import { HashRouter, Link, Route, Routes } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { Box, Icon, IconButton, Stack, HStack, Text, Spacer, Flex } from '@chakra-ui/react';
import { MenuIcon, CloseIcon, LanguageIcon } from './icons/icons';
import { galleryPhotographyImages, productPhotographyImages, vehiclesPhotographyImages, housesPhotographyImages } from './constants';
import Home from './Home';
import About from './About';
import Reel from './Reel';
import Design from './Design';
import Video from './Video';
import ScrollToTop from './ScrollToTop';
import PhotographyBrowser from './PhotographyBrowser';
import FotografiaGaleria from './FotografiaGaleria';
import SimpleGallery from './SimpleGallery';



function NavBar() {

    const [displayMenu, setDisplayMenu] = useState(false);
    const langFile = require('./data/lang.json');
    const [lang,setLang] = useState('ES');
    const [currentLangData,setCurrentLangData] = useState(langFile[lang]);
    const [displayProjects, setDisplayProjects] = useState('none');
    const [toggleNavMenu, setToggleNavMenu] = useState(false);

    useEffect(() => {
      setCurrentLangData(langFile[lang]);
    }, [langFile,lang]);

    const toogleLang = () => {
      var newLang;
      lang === 'ES' ? newLang = 'EN' : newLang = 'ES';
      return newLang;
    }
  
    const toogleDisplayProjects = () => {
      displayProjects === 'none' ? setDisplayProjects('block') : setDisplayProjects('none');
      setToggleNavMenu(!toggleNavMenu);
    }


    return(
      <HashRouter>
        <ScrollToTop />
        <Flex direction={['column','row','row','row']} spacing='0px' w='100%' position="fixed" zIndex='10'  >
          <HStack w='100%' h='4rem' justifyContent='space-around' px='4%' alignItems='center' color='black' fontWeight={700} bg='white'>
            <Box>
              <Link to="/"> <Text fontSize={'xl'} fontStyle='inter' > Pedro Serrano </Text> </Link>
            </Box>

            <Spacer />

            {/* Links desktop */}
            <Stack direction='row' gap={2} >
              <Box display={['none','block','block','block']}>
                <Stack direction={'row'} gap={10} >  
                  <Flex textAlign='center' direction='column' onClick={ () => toogleDisplayProjects() } cursor={'pointer'} position='relative'>
                    <Text fontSize={'md'} _hover={{ opacity: 0.7 }} transitionDuration='0.5s' > {currentLangData.NavBar.opciones[2]} </Text>
                    <Stack
                      opacity={ toggleNavMenu ? 1 : 0 }
                      direction='column'
                      position='absolute' top='110%' right={'-50%'}
                      px='2rem' pt='1.3rem' pb='0.7rem' bgColor='white' borderRadius='7%'
                      boxShadow={'xl'}
                      w={'auto'}
                      transition='all 0.2s ease-in' zIndex='7'
                      textAlign={'center'}
                      >
                      <Link to="/photography"> <Text fontSize={'md'} fontWeight='400' py='4%' _hover={ {fontWeight: '500'} }> {currentLangData.ProjectsGallery.Foto.tit} </Text> </Link>
                      <Link to="/video"> <Text fontSize={'md'} fontWeight='400' py='4%' _hover={ {fontWeight: '500'} }> {currentLangData.ProjectsGallery.Video.tit} </Text> </Link>
                      <Link to="/design"> <Text fontSize={'md'} fontWeight='400' py='4%' _hover={ {fontWeight: '500'} }> {currentLangData.ProjectsGallery.Disenio.tit} </Text> </Link>
                    </Stack>
                  </Flex>
                  <Link to="/about"> <Text fontSize={'md'} _hover={{ opacity: 0.8 }} transitionDuration='0.5s'> {currentLangData.NavBar.opciones[0]} </Text> </Link>
                  <Link to="/reel"> <Text fontSize={'md'} _hover={{ opacity: 0.8 }} transitionDuration='0.5s'> {currentLangData.NavBar.opciones[1]}  </Text> </Link>
                </Stack>
              </Box>
            </Stack>

            <Stack direction='row' alignItems='center' pl='2%' cursor='pointer' onClick={() => setLang(toogleLang())}>
              <Icon as={LanguageIcon} w={6} h={6} />
              <Text color='black' fontSize='sm'><b>{lang}</b></Text>
            </Stack>

            <IconButton display={['flex','none','none','none']} size={'md'}  color={'black'} bgColor='white' px='2%'
                        icon={ displayMenu ? <CloseIcon /> : <MenuIcon />}
                        onClick={() => setDisplayMenu(!displayMenu)}  />  

          </HStack>
          {/* NavMenu cellphone */}
          <Stack direction='column' display={{base: displayMenu ? 'block' : 'none', md: 'none', lg: 'none', xl: 'none'}} 
                p='5%' bgColor='white' color='black' textAlign={'center'}>
            <HashLink smooth to="/#projects"> <Text py='1%'> {currentLangData.NavBar.opciones[2]} </Text> </HashLink>
            <Link to="/about"> <Text py='1%'> {currentLangData.NavBar.opciones[0]} </Text> </Link>
            <Link to="/reel"> <Text py='1%'> {currentLangData.NavBar.opciones[1]} </Text> </Link>
          </Stack>
    
        </Flex>
  
  
        <Routes>
          <Route path="/" element={<Home text={currentLangData} />}/>
          <Route path="/about" element={<About text={currentLangData.About} />} />
          <Route path="/reel" element={<Reel text={currentLangData.Reel} />} />
          <Route path="/photography" element={<PhotographyBrowser lang={lang} />} />
          <Route path="/design" element={<Design text={currentLangData.Design} />} />
          <Route path="/video" element={<Video text={currentLangData.Video} />} />
          <Route
            path="/photography/photo"
            element={
                <FotografiaGaleria
                  text={currentLangData.Fotografia}
                  currentLang={lang}
                  imgList={galleryPhotographyImages}
                />
              }      
          />
          <Route
            path="/photography/products"
            element={
                <SimpleGallery
                  text={currentLangData.Producto}
                  currentLang={lang}
                  imgList={productPhotographyImages}
                />
              }      
          />
          <Route
            path="/photography/vehicles"
            element={
                <SimpleGallery
                  text={currentLangData.Vehiculos}
                  currentLang={lang}
                  imgList={vehiclesPhotographyImages}
                />
              }      
          />
          {/* <Route
            path="/photography/houses"
            element={
                <SimpleGallery
                  text={currentLangData.Inmuebles}
                  currentLang={lang}
                  imgList={housesPhotographyImages}
                />
              }      
          /> */}
        </Routes>
      
      </HashRouter>
    );
  }
  
  
  export default NavBar;